"use client";

import { useTranslation } from "@/lib/i18n";

export default function LanguageToggle() {
  const { locale, setLocale } = useTranslation();

  return (
    <div className="flex items-center gap-1 text-xs font-mono tracking-widest">
      <button
        onClick={() => setLocale("de")}
        className={`px-2 py-1 transition-colors ${
          locale === "de"
            ? "text-mint-text border-b border-mint-text"
            : "text-text-faint hover:text-text-secondary"
        }`}
        aria-label="Deutsch"
      >
        DE
      </button>
      <span className="text-text-faintest">|</span>
      <button
        onClick={() => setLocale("en")}
        className={`px-2 py-1 transition-colors ${
          locale === "en"
            ? "text-mint-text border-b border-mint-text"
            : "text-text-faint hover:text-text-secondary"
        }`}
        aria-label="English"
      >
        EN
      </button>
    </div>
  );
}
